import { createServerFn } from "@tanstack/react-start";

export const getManagedSignup = createServerFn({ method: "GET" })
  .inputValidator((data: { token: string }) => data)
  .handler(async ({ data }) => {
    const { fetchSignupByToken } = await import("@/lib/signup-manage.server");
    return fetchSignupByToken(data.token);
  });

export const releaseManagedSignup = createServerFn({ method: "POST" })
  .inputValidator((data: { token: string; origin?: string }) => data)
  .handler(async ({ data }) => {
    const { releaseSignupByToken } = await import("@/lib/signup-manage.server");
    const { result, signupId } = await releaseSignupByToken(data.token);

    if (result === "released" && signupId) {
      const { notifyAdminsOfRelease, resolveOrigin } = await import("@/lib/events.server");
      await notifyAdminsOfRelease(signupId, resolveOrigin(data.origin), "volunteer");
    }

    return { result };
  });
